import { defineComponent as _defineComponent } from 'vue'
import { mergeProps as _mergeProps, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, isRef as _isRef, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2bea5789"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = ["src"]



type Props = {
  loggedIn: boolean;
  name: string;
  profilePic: string;
  generatedPic: string;
  imgLoading: boolean;
  spriteError: string;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'CurrentUserDetailsView',
  props: {
    loggedIn: { type: Boolean },
    name: null,
    profilePic: null,
    generatedPic: null,
    imgLoading: { type: Boolean },
    spriteError: null
  },
  emits: [
  "saveProfilePic",
  "saveDisplayName",
  "generateNewImage",
],
  setup(__props: any, { emit: emits }) {

const props = __props as {
  loggedIn: boolean;
  name: string;
  profilePic: string;
  generatedPic: string;
  imgLoading: boolean;
  spriteError: string;
};



const nameRules = [
  (v: string) => v.length >= 5 || "Name must be at least 5 characters",
  (v: string) => v.length <= 20 || "Name must be at most 20 characters",
];

let newName = "";



const saveProfilePicPressed = () => {
  emits("saveProfilePic", props.generatedPic);
};

const saveDisplayNamePressed = () => {
  emits("saveDisplayName", newName);
};

const generateNewImagePressed = () => {
  emits("generateNewImage");
};

return (_ctx: any,_cache: any) => {
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_text_field = _resolveComponent("v-text-field")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_dialog, {
      width: "500",
      transition: "dialog-bottom-transition"
    }, {
      activator: _withCtx(({ props }) => [
        _createElementVNode("img", _mergeProps(props, {
          class: "sprite",
          src: 'data:image/png;base64,' + __props.profilePic,
          alt: ""
        }), null, 16, _hoisted_1),
        _createVNode(_component_v_tooltip, {
          activator: "parent",
          location: "bottom"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Click on your avatar or name to change it ")
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_v_card, { class: "text-center" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createTextVNode(" Change your profile picture ")
              ]),
              _: 1
            }),
            _createElementVNode("img", {
              class: "sprite",
              src: 'data:image/png;base64,' + __props.generatedPic,
              alt: "Current Sprite"
            }, null, 8, _hoisted_2),
            (__props.imgLoading)
              ? (_openBlock(), _createBlock(_component_v_progress_linear, {
                  key: 0,
                  indeterminate: ""
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_v_btn, {
              disabled: __props.imgLoading,
              onClick: generateNewImagePressed
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Randomize new Image ")
              ]),
              _: 1
            }, 8, ["disabled"]),
            _createVNode(_component_v_card_actions, { class: "align-self-end" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  color: "primary",
                  onClick: saveProfilePicPressed
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Save image")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        (__props.spriteError)
          ? (_openBlock(), _createBlock(_component_v_alert, {
              key: 0,
              type: "error",
              density: "compact",
              closable: "",
              location: "center"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(__props.spriteError), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_v_dialog, {
      width: "500",
      transition: "dialog-bottom-transition"
    }, {
      activator: _withCtx(({ props }) => [
        _createElementVNode("h4", _mergeProps(props, { class: "pa-8" }), _toDisplayString(__props.name), 17)
      ]),
      default: _withCtx(() => [
        _createVNode(_component_v_card, { class: "text-center" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createTextVNode(" Change your display name ")
              ]),
              _: 1
            }),
            _createVNode(_component_v_text_field, {
              rules: nameRules,
              class: "text-field pl-4 pr-4",
              onInput: _cache[0] || (_cache[0] = (event) => (_isRef(newName) //@ts-ignore
 ? newName.value = event.target.value : newName = event.target.value))
            }),
            _createVNode(_component_v_card_actions, { class: "align-self-end" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  disabled: __props.name.length === 0,
                  block: "",
                  color: "primary",
                  onClick: saveDisplayNamePressed
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Save name")
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}
}

})